<template>
  <div class="avatar-menu">
    <el-dropdown @command="userOpt" trigger="click">
      <el-avatar icon="el-icon-user-solid" class="avatar-img" :size="35" :src="avatar"></el-avatar>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="reset">修改密码</el-dropdown-item>
        <el-dropdown-item command="quite">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <reset-password v-if="resetPassword.visible" :dialog-data="resetPassword"/>
  </div>
</template>

<script>
  import ResetPassword from "../dialog/ResetPassword"
  export default {
    name: "AvatarMenu",
    components: {ResetPassword},
    data() {
      return {
        avatar: "",
        resetPassword: {title: "修改密码", visible: false, width: 400},
      }
    },
    methods: {
      userOpt(command) {
        switch (command) {
          case "reset": this.reset();break;
          case "quite": this.quite();break;
        }
      },
      reset() {
        this.resetPassword.visible = true;
      },
      // 注销
      quite() {
        this.openConfirm('退出登录', async () => {
          let res = await this.$Http.logout();
          if (res) {
            this.$router.push({name: "login"}).catch(() => {});
            this.msgSuccess('操作成功！');
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .avatar-menu {
    display: inline-block;
    vertical-align: middle;
    font-size: 0;
    .avatar-img:hover {
      background-color: #fff;
      color: #C0C4CC;
    }
    .el-dropdown {
      font-size: 0;
    }
  }
</style>
